import React, { useState } from 'react';
import { Plus } from 'lucide-react';
import { toast } from 'sonner';
import { api, errText } from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import {
  Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, DialogTrigger,
} from '@/components/ui/dialog';

const EMPTY = { name: '', event_date: '', registration_link: '', support_whatsapp: '' };
const FIELDS = [
  ['name', 'Nombre del evento', 'Vigilia junio 2026', 'text'],
  ['event_date', 'Fecha', '', 'date'],
  ['registration_link', 'Link de registro de la iglesia', 'https://...', 'url'],
  ['support_whatsapp', 'WhatsApp de soporte', '+58 412 000 0000', 'text'],
];

export function NewCampaignDialog({ onCreated }) {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(EMPTY);
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setBusy(true);
    try {
      const { data } = await api.post('/campaigns', form);
      toast.success('Evento creado');
      setOpen(false);
      setForm(EMPTY);
      onCreated(data.id);
    } catch (e) {
      toast.error(errText(e, 'No se pudo crear el evento'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button data-testid="campaign-new-button"><Plus className="h-4 w-4 mr-1" />Nuevo evento</Button>
      </DialogTrigger>
      <DialogContent data-testid="campaign-new-dialog">
        <DialogHeader>
          <DialogTitle>Nuevo despliegue ministerial</DialogTitle>
          <DialogDescription>Luego podrás cargar el CSV y editar el mensaje de bienvenida.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          {FIELDS.map(([k, label, ph, type]) => (
            <div key={k} className="space-y-1">
              <Label htmlFor={`campaign-${k}`}>{label}</Label>
              <Input id={`campaign-${k}`} type={type} placeholder={ph} value={form[k]}
                onChange={(e) => setForm({ ...form, [k]: e.target.value })} data-testid={`campaign-new-${k}`} />
            </div>
          ))}
        </div>
        <DialogFooter>
          <Button onClick={submit} disabled={busy || form.name.trim().length < 2} data-testid="campaign-new-submit">
            {busy ? 'Creando...' : 'Crear evento'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
